import React, {useState, useEffect, JSX, useRef} from "react";
import "./styles/Rmt.css";
import { ModeSpinner } from "./components/Spinner";
import { SpinButton } from "./components/SpinButton";
import { Spud } from "./components/Spud";
import {Restrictions, Themes} from "./Lists";

export function RandomMapTheme() {
   const [spinKey, setSpinKey] = useState(0);
   const [spawnSpuds, setSpawnSpuds] = useState<JSX.Element[]>([]);

   const handleSpinAll = () => {
      setSpinKey(prev => prev + 1);
   };

   const loopRunning = useRef(false);

   useEffect(() => {
      if (loopRunning.current) return;
      loopRunning.current = true;

      const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

      const spawnLoop = async () => {
         while (true) {
            setSpawnSpuds(prev => [...prev, <Spud key={Date.now() + Math.random()} />]);
            const next = 10000 + Math.random() * 7000;
            await sleep(next);
         }
      };

      spawnLoop();
   }, []);

   return (
      <div className="rmt-window">
         <img className="background-image" src={`${process.env.PUBLIC_URL}/images/rmt/bg.png`} alt="" />

         <h2>Theme</h2>
         <ModeSpinner options={Themes} spinTrigger={spinKey} spinDuration={3000} delay={0} />

         <h2>Restriction</h2>
         <ModeSpinner options={Restrictions} spinTrigger={spinKey} spinDuration={3500} delay={200} />

         <SpinButton onClick={handleSpinAll} />

         {spawnSpuds}
      </div>
   );
}